import { Entities } from '../types';

var findLinkEntities = function findLinkEntities(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges(function (character) {
    var entityKey = character.getEntity();
    return entityKey !== null && [Entities.AffiliationLink, Entities.ExternalLink, Entities.InternalLink].includes(contentState.getEntity(entityKey).getType());
  }, callback);
};

export default findLinkEntities;